import React from 'react'
import { Doughnut } from 'react-chartjs-2'

export default function DoughnutChart({ data, options = {}, ...props }) {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    cutout: '60%'
  }

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    plugins: {
      ...defaultOptions.plugins,
      ...options.plugins
    }
  }

  return <Doughnut data={data} options={mergedOptions} {...props} />
}
